import React, { useEffect, useState, useRef } from 'react';
import Header from '../../components/Header/Header';
import { baseUrl } from '../../Urls';
import TermPicker from '../../components/TermPicker/TermPicker';
import '../Management/management.css';

function Management() {
  const [salesList, setSalesList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    statuses: new Set(),
  });
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const totalAmount = filteredList.reduce((sum, sale) => sum + (sale.amount || 0), 0);
  const totalEnquiry = filteredList.length;

  const fetchSales = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${baseUrl}/api/sales`, {
        method: 'GET',
        credentials: 'include',
      });
      const data = await res.json();
      setSalesList(data);
      setFilteredList(data);
    } catch (err) {
      console.error('Error fetching sales:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSales();
  }, []);

  useEffect(() => {
    let filtered = salesList;

    filtered = filtered.filter(sale => {
      const status = (sale.status || '').toLowerCase();
      return ['won', 'pipeline', 'lose'].includes(status);
    });

    // Filter by Enq date
    if (filters.startDate && filters.endDate) {
      const start = new Date(filters.startDate);
      const end = new Date(filters.endDate);
      end.setMonth(end.getMonth() + 1);
      end.setDate(0);
      end.setHours(23, 59, 59, 999);

      filtered = filtered.filter(sale => {
        const enqDate = new Date(sale.date);
        return enqDate >= start && enqDate <= end;
      });
    }

    // Filter by status
    if (filters.statuses.size > 0) {
      filtered = filtered.filter(sale => {
        const normalizedStatus = (sale.status || '').toLowerCase();
        return Array.from(filters.statuses).some(s => s.toLowerCase() === normalizedStatus);
      });
    }
    setFilteredList(filtered);
  }, [filters, salesList]);


  const handleDateFilter = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name === 'start' ? 'startDate' : 'endDate']: value }));
  };

  // const handlePoStatus = async (id, status) => {
  //   try {
  //     const res = await fetch(`${baseUrl}/api/sales/po-status/${id}`, {
  //       method: 'PUT',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ poStatus: status }),
  //     });

  //     if (res.ok) {
  //       fetchSales();
  //     } else {
  //       console.error('Status update failed');
  //     }
  //   } catch (err) {
  //     console.error('Error updating PO status:', err);
  //   }
  // };

  const tableContainerRef = useRef(null);

  useEffect(() => {
    if (salesList.length && tableContainerRef.current) {
      tableContainerRef.current.scrollTop = tableContainerRef.current.scrollHeight;
    }
  }, [salesList]);

  const columns = [
    { key: "sNo", label: "SNo" },
    { key: "date", label: "Enq Date" },
    { key: "companyName", label: "Company Name" },
    { key: "contactPerson", label: "Contact Person" },
    { key: "phone", label: "Phone" },
    {
      key: "estAttachments",
      label: "EST Sheet",
      render: (sale) =>
        sale.estAttachments?.map((link, i) => (
          <div key={i}>
            <a href={link} target="_blank" rel="noopener noreferrer">
              View File {i + 1}
            </a>
          </div>
        )) || "-"
    },
    {
      key: "qutPdf",
      label: "Quatation Proposal",
      render: (sale) =>
        sale.qutPdf?.map((link, i) => (
          <div key={i}>
            <a href={link} target="_blank" rel="noopener noreferrer">
              View File {i + 1}
            </a>
          </div>
        )) || "-"
    },
    { key: 'approvedBy', label: 'Approved By' },
    { key: "source", label: "Source" },
    { key: 'assignedTo', label: 'Assigned To' },
    { key: 'status', label: 'Status' },
    { key: 'reason', label: 'Reason' },
    {
      key: 'poAttachments',
      label: 'PO Attcahments Link',
      render: (sale) =>
        sale.poAttachments?.map((link, i) => (
          <div key={i}>
            <a href={link} target='_blank' rel='noopener noreferrer'>
              View File {i + 1}
            </a>
          </div>
        )) || '-'
    },
    { key: 'amount', label: 'Amount', render: (sale) => sale.amount?.toLocaleString('en-IN') || '-' },

    // { key: "estDate", label: "EST Date", render: (sale) => sale.estDate || "_" },
    // { key: "soDate", label: "Follow-up Date", render: (sale) => sale.soDate || "_" },
    // { key: "productName", label: "Product Name" },
    // { key: "addressLine1", label: "Address" },
    // { key: 'tel', label: 'Telephone' },
    // { key: "email", label: "Email" },
    // {
    //   key: "attachments", label: "Lead Attachments",
    //   render: (sale) => (
    //     sale.attachments?.map((link, i) => (
    //       <div key={i}>
    //         <a href={link} target='_blank' rel='noopener noreferrer'>
    //           View File{i + 1}
    //         </a>
    //       </div>
    //     )) || "_"
    //   )
    // },
    // { key: "scope", label: "Scope" },
    // { key: "source", label: "Source" },
    // { key: "quotationNo", label: "Quotation No" },
    // { key: "amount", label: "Amount", render: (sale) => sale.amount?.toLocaleString("en-IN") || "-" },
    // {
    //   key: "poStatus",
    //   label: "Proposal Status",
    //   render: (sale) => (
    //     <span
    //       className={`badge ${sale.poStatus === "approved"
    //         ? "bg-success"
    //         : sale.poStatus === "rejected"
    //           ? "bg-danger"
    //           : "bg-warning text-dark"
    //         }`}
    //     >
    //       {sale.poStatus || "pending"}
    //     </span>
    //   )
    // },
    // {
    //   key: "managementAction",
    //   label: "Management Action",
    //   render: (sale) => (
    //     <>
    //       <button
    //         className="btn btn-success btn-sm me-2"
    //         onClick={() => handlePoStatus(sale._id, "approved")}
    //       >
    //         Approve
    //       </button>
    //       <button
    //         className="btn btn-danger btn-sm"
    //         onClick={() => handlePoStatus(sale._id, "rejected")}
    //       >
    //         Reject
    //       </button>
    //     </>
    //   )
    // },
    // { key: "status", label: "Status" },
    // { key: "note", label: "Lead Note" },
  ];

  return (
    <>
      <div className='container-fluid'>
        <Header salesList={salesList} />
        <div className="container estimation-container" style={{ marginTop: "100px" }}>
          <h2 className='ceo-heading' style={{ color: "white", fontFamily: "italic" }}>Management Page</h2>
          <div className="table-container-management p-0" style={{ overflowX: "auto" }} ref={tableContainerRef}>
            {loading ? (
              <div className="spinner-container">
                <div className="spinner"></div>
                <p>Loading Management data...</p>
              </div>
            ) : (
              <table className="table table-bordered ceo-table table-hover" style={{ fontSize: "14px", whiteSpace: "nowrap", minWidth: "1200px" }}>
                <thead>
                  <tr>
                    {columns.map((col) => (
                      <th key={col.key}>{col.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredList.length === 0 ? (
                    <tr>
                      <td colSpan="25" className="text-left text-dark">
                        No data found
                      </td>
                    </tr>
                  ) : (
                    filteredList.map((sale) => (
                      // return (
                      <tr
                        key={sale._id}
                        onClick={() => setSelectedRow(prev => (prev === sale._id ? null : sale._id))}
                        className={selectedRow === sale._id ? 'highlight-row' : ''}
                        style={{ cursor: "pointer" }}
                      >
                        {columns.map((col) => (
                          <td key={col.key}>
                            {col.render ? col.render(sale) : sale[col.key] ?? " "}
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* <div className='col-sm-5 col-lg-3'> */}
          <div className='row'>
            <div className='col-12 col-md-6'>
              <h6 className='status-title'>Status</h6>
              {['won', 'lose', 'pipeline'].map(status => (
                <div className="form-check" style={{ color: "white" }} key={status}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="statusFilter"
                    id={`status-${status}`}
                    checked={filters.statuses.has(status)}
                    onChange={(e) => {
                      const updated = new Set();
                      if (e.target.checked) updated.add(status);
                      setFilters(prev => ({ ...prev, statuses: updated }));
                    }}
                  />
                  <label className="form-check-label" htmlFor={`status-${status}`}>
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                  </label>
                </div>
              ))}
              <TermPicker
                startName="start"
                endName="end"
                onChange={handleDateFilter}
              />
            </div>
            <div className='col-12 col-md-6 total'>
              <p>Amount: {totalAmount.toLocaleString('en-IN')}</p>
              <p>Enquiry: {totalEnquiry}</p>
            </div>
          </div>

          {/* </div> */}
        </div>
      </div>
    </>
  )
}

export default Management